/* eslint-disable */
import { useTranslation as useUiTranslation } from "react-i18next";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import QuillEditor from "./TextEditor";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelector } from "react-redux";
import apicache from "../../clearCach/clear";
import { useDispatch } from "react-redux";
import { applyStoreDraft } from "../../../redux/store/store";
import workerAPI from "../../../api/worker/worker_service";

const Model2 = ({ show, setShow, data, setData }) => {
  const { t: uiT } = useUiTranslation();
  const MySwal = withReactContent(Swal);
  const products = useSelector((state) => state.ProductsReducer);
  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const dispatch = useDispatch();
  const handleClose = () =>
    setShow({
      model1: false,
      model2: false,
      model3: false,
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    apicache();
    try {
      const result = await workerAPI.updateStoreDraft(store, data);
      dispatch(applyStoreDraft(store, result.store));

      Swal.fire({
        icon: "success",
        title: uiT("settings.success"),
        confirmButtonText: uiT("ship.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: uiT("Products.ImportModal.error"),
        text: uiT("ui.notSaved"),
        confirmButtonText: uiT("ship.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} size="lg" className="w-100">
        <Modal.Header>
          <Modal.Title>{uiT("ui.returnsPolicy")}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <QuillEditor data={data} setData={setData} type={"return"} />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit">
              {uiT("common.save")}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default Model2;
